import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@repo/ui/components/dialog';
import { Drawer } from '@/components/ui/drawer';
import { CreateOpenMatchForm } from './create-open-match-form';
import { Court, Category, WebOpenMatch } from '@repo/shared-types';
import { useIsMobile } from '@repo/ui/hooks/use-mobile';

interface OpenMatchModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  courts: Court[];
  categories: Category[];
  initialData?: WebOpenMatch;
}

export function OpenMatchModal({
  open,
  onOpenChange,
  courts,
  categories,
  initialData,
}: OpenMatchModalProps) {
  const isMobile = useIsMobile();
  const isEditMode = !!initialData;

  const content = (
    <div className="p-4">
      <DialogTitle className="mb-2">
        {isEditMode ? 'Editar Partido Abierto' : 'Crear Partido Abierto'}
      </DialogTitle>
      <DialogDescription className="mb-4">
        {isEditMode
          ? 'Modifica los datos del partido abierto'
          : 'Completa los campos para crear un nuevo partido abierto'}
      </DialogDescription>
      <CreateOpenMatchForm
        courts={courts}
        categories={categories}
        onClose={() => {
          onOpenChange(false);
        }}
        initialData={initialData}
      />
    </div>
  );

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <div className="pb-4 max-h-[90vh] overflow-y-auto">{content}</div>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">{content}</DialogContent>
    </Dialog>
  );
}
